import * as swcHelpers from '@swc/helpers';
import React__default, { useContext, createContext } from 'react';
import { getDisplayName } from '@grandvisionhq/utils';

const CheckoutSettingsContext = /*#__PURE__*/ createContext(null);
const CheckoutSettingsConsumer = CheckoutSettingsContext.Consumer;
CheckoutSettingsContext.displayName = 'CheckoutSettings';
const useCheckoutSettings = ()=>{
    const context = useContext(CheckoutSettingsContext);
    if (context === null) {
        throw new Error('Missing CheckoutSettings provider. You have to wrap the application with the CheckoutSettingsProvider component from the @grandvisionhq/checkout-v2 package.');
    }
    return context;
};
function withCheckoutSettings(Component) {
    const displayName = getDisplayName(Component);
    // this is intented to be used with any kind of react component. The props can't be known at this point.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function WithCheckoutSettings(props) {
        const context = useCheckoutSettings();
        return /*#__PURE__*/ React__default.createElement(Component, swcHelpers.extends({}, props, {
            checkoutSettings: context
        }));
    }
    WithCheckoutSettings.displayName = `WithCheckoutSettings(${displayName})`;
    return WithCheckoutSettings;
}

export { CheckoutSettingsConsumer, CheckoutSettingsContext, useCheckoutSettings, withCheckoutSettings };
//# sourceMappingURL=context.js.map
